import './style.scss';
import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginAction, editClientData, getCompanyPermissions, refreshUserAction, refreshToken, refreshAuth, allCompanies } from '../../store/actions';
import { Route, Switch } from "react-router-dom";
import { TabsLogs } from '../reports/logs';
import { tokenAboutToExpire } from '../../utils/helpers';

import adjustment401kView from '../reports/payroll-comparisons/401K-adjustment';
import AdminLogin from "../login/index-admin";
import AnnualBillingReportView from '../reports/annual-billing';
import AnnualBillingView from '../Admin/report-settings/annual-billing';
import AparComparisonSetupView from '../Admin/report-settings/APAR-Comparison/report-setup';
import BillingDiscrepancy from '../reports/billing-discrepancy/billing-discrepancy';
import BillingServices from '../Admin/report-settings/billing-services';
import BillingView from '../Admin/report-settings/billing-discrepancy';
import CertifiedPayroll from "../reports/certified-payroll";
import ClientFunctionality from '../reports/client-functionality';
import ClientsView from "../Admin/Clients";
import CountersTEReport from '../reports/counters-te';
import CSRAssignments from '../Admin/report-settings/csr-assignments';
import CSRAssignmentsReport from '../reports/csr-assignments';
import DeductionComparisonView from '../reports/payroll-comparisons/deduction-comparison';
import DistributionComparisonView from '../reports/payroll-comparisons/distribution-comparison';
import dailyScheduleReport from '../reports/daily-schedule-report';
import EmailSetup from '../email-setup';
import EmployeeAccruals from "../reports/accruals";
import HeaderView from "../../components/header";
import HolidayPrintingReport from '../reports/holiday-printing/holiday-printing';
import LocationWage from "../Admin/wage";
import ManagementBillingView from '../Admin/report-settings/management-overview';
import ManagementOverview from '../reports/management-overview/managementOverview';
import njCertifiedPayroll from '../reports/nj-certified-payroll';
import NoPayrollActivityView from "../reports/no-payroll-activity";
import PatientHoursView from "../reports/patient-hours";
import PermissionList from '../../assets/data/permissionList.json';
import PPDBudgetView from "../PPD/budget";
import PPDCensusView from '../PPD/census';
import PPDContHoursView from "../PPD/contractHours";
import PPDOverview from "../PPD/overview";
import RoleView from '../Admin/Role';
import SideMenu from "../../components/side-menu/index";
import TabsLatePayrolls from "../reports/tabs-late-payroll";
import TaxCollectionView from "../file-conversions";
import TimeInventory from '../time-inventoy';
import TurnoverRate from "../reports/turnover-rate";
import ukgInvoices from '../Admin/report-settings/APAR-Comparison/ukg-invoices';
import Users from "../Admin/Users";
import WageParityView from "../reports/wage-parity";

class HomeView extends Component {
  state = {
    ShowSidebar: false,
    active: false,
    mobClass: 'hellll',
    HoverSidebarName: null,
    clock: null,
    VITE_VERSION: import.meta.env.VITE_VERSION
  };

  toggleHeader = () => {
    const currentState = this.state.active;
    this.setState({ active: !currentState });
    this.setState({ mobClass: "" })
  };

  async componentDidMount() {
    if (!this.props.UserReducer || !Object.keys(this.props.UserReducer).length) {
      this.props.history.push('/login');
    }
    else {
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));
      this.state.clock = setInterval(() => {
        if (tokenAboutToExpire(this.props.UserReducer.token)) {
          this.props.refreshToken();
        };
        if (tokenAboutToExpire(this.props.UserReducer.authorization)) {
          this.props.refreshAuth();
        };
      }, 300000);
      if (this.isPermission("CLIENT_LIST")) {
        await this.props.allCompanies();
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
    clearInterval(this.state.clock);
  };

  isPermission(key, isGroupPermission) {
    let { permissions } = this.props.UserReducer;
    let hasPermission;
    if (isGroupPermission) {
      hasPermission = this.findInGroup(permissions, this.getPermissionGroup(key));
    }
    else {
      hasPermission = this.findPermission(permissions, key);
    };
    return hasPermission;
  };

  findPermission = (permissions, key) => {
    return permissions?.find(p => p.key === key && p.isActive);
  };

  findInGroup = (permissions, group) => {
    let inGroup = permissions?.filter(p => {
      return p.isActive && group.find(pl => pl.key === p.key)
    });
    return inGroup && inGroup.length;
  };

  getPermissionGroup = (groupKey) => {
    let permissionGroup = PermissionList.filter(p => p.group === groupKey);
    return permissionGroup;
  };


  updateDimensions() {
    if (window.innerWidth <= 992) {
      this.setState({ mobClass: "mobie-sidebar" });
    } else {
      this.setState({ mobClass: "" });
    };
  };

  hoverOn = () => {
    this.setState({ HoverSidebarName: "MouseEnter" });
  };
  hoverOff = () => {
    this.setState({ HoverSidebarName: "MouseOut" });
  };

  backAdmin = ($e) => {

    $e.preventDefault();
    const { prevPermissions, prevRole, prevCompany, company, companyDetails } = this.props.UserReducer;
    /* this.props.UserReducer.role = prevRole;
    this.props.UserReducer.company = prevCompany;
    this.props.UserReducer.LOGIN_AS = false;
    this.props.UserReducer.prevRole = null;
    this.props.UserReducer.prevCompany = company;
    this.props.UserReducer.permissions = prevPermissions;
    this.props.UserReducer.companyId = this.props.UserReducer.companyDetails._id;
    this.props.UserReducer.compSystemId = this.props.UserReducer.companyDetails.companyId */
    localStorage.setItem('USER', JSON.stringify({
      ...this.props.UserReducer,
      role: prevRole,
      company: prevCompany,
      LOGIN_AS: false,
      prevRole: null,
      prevCompany: company,
      permissions: prevPermissions,
      companyId: companyDetails._id,
      prevPermissions: null
    }));
    this.props.refreshUserAction();
    // this.setState   
    this.props.history.replace(`/clients`);
  };

  render() {
    //this.refreshTokenBeforeExpire();
    return (

      <div className="container-fluid">
        <HeaderView history={this.props.history} clickHeader={this.toggleHeader} />
        <div className="body-outer">
          <div className="row">
            <SideMenu className={`${this.state.active ? 'hide-sidebar' : 'show-sidebar'} ${this.state.mobClass} ${this.state.HoverSidebarName} `} hoverOn={this.hoverOn} hoverOff={this.hoverOff} backAdmin={this.backAdmin} />
            {/* {
              (this.props.getPermissionActive.length ? true : false) && ( */}
            <div className={`page-wrapper ${this.state.active ? 'full_wrapper' : 'short_wrapper'} ${this.state.mobClass ? 'full_mobile_wrapper' : 'short_mobile_wrapper'} ${this.state.HoverSidebarName}`}>
              <Switch>
                {this.isPermission('WAGE_PARITY') && (<Route exact path='/reports/wage-parity' component={WageParityView} />)}
                {this.isPermission('PATIENT_HOURS') && (<Route exact path='/reports/patient-hours' component={PatientHoursView} />)}
                {this.isPermission('PAYROLL_DEDUCTION_COMPARISON') && (<Route exact path='/reports/deduction-comparison' component={DeductionComparisonView} />)}
                {this.isPermission('PAYROLL_DISTRIBUTION_COMPARISON') && (<Route exact path='/reports/distribution-comparison' component={DistributionComparisonView} />)}
                {this.isPermission('401K_ADJUSTMENT') && (<Route exact path='/reports/401k-adjustment' component={adjustment401kView} />)}
                {this.isPermission('CERTIFIED_PAYROLL') && (<Route exact path='/reports/certified-payroll' component={CertifiedPayroll} />)}
                {this.isPermission('COUNTERS_TE_REPORT') && (<Route exact path='/reports/counters-te-report' component={CountersTEReport} />)}
                {this.isPermission('NJ_CERTIFIED') && (<Route exact path='/reports/nj-certified-payroll' component={njCertifiedPayroll} />)}
                {this.isPermission('EMPLOYEES_ACCRUALS') && (<Route exact path='/reports/accruals' component={EmployeeAccruals} />)}
                {this.isPermission('TURNOVER_RATE') && (<Route exact path='/reports/turnover' component={TurnoverRate} />)}
                {this.isPermission('FILE_CONVERSION', true) && (<Route exact path='/file-conversions' component={TaxCollectionView} />)}
                {this.isPermission('NO_PAYROLL_ACTIVITY') && (<Route exact path='/reports/no-payroll-activity' component={NoPayrollActivityView} />)}
                {this.isPermission("LATE_PAYROLL") && (<Route exact path='/reports/late-payroll' component={TabsLatePayrolls} />)}
                {this.isPermission("ANNUAL_BILLING") && (<Route exact path='/reports/annual-billing' component={AnnualBillingReportView} />)}
                {this.isPermission('CSR_ASSIGNMENT') && (<Route exact path='/reports/csr-assignments' component={CSRAssignmentsReport} />)}
                {this.isPermission('HOLIDAY_PRINTING') && (<Route exact path='/reports/holiday-printing' component={HolidayPrintingReport} />)}
                {this.isPermission('CLIENT_FUNCTIONALITY') && (<Route exact path='/reports/client-functionality' component={ClientFunctionality} />)}
                {this.isPermission('BILLING_DISCREPANCY') && (<Route exact path='/reports/billing-discrepancy' component={BillingDiscrepancy} />)}
                {this.isPermission('MANAGEMENT_OVERVIEW') && (<Route exact path='/reports/management-overview' component={ManagementOverview} />)}
                {this.isPermission("PPD_CENSUS_DATA") && (<Route exact path='/ppd/census-data' component={PPDCensusView} />)}
                {this.isPermission("SCHEDULER_REPORTS") && (<Route exact path='/reports/scheduler-daily' component={dailyScheduleReport} />)}
                {this.isPermission("PPD_CENSUS_DATA") && (<Route exact path='/ppd/budget' component={PPDBudgetView} />)}
                {this.isPermission("PPD_CENSUS_DATA") && (<Route exact path='/ppd/contract-hours' component={PPDContHoursView} />)}
                {this.isPermission("PPD_CENSUS_DATA") && (<Route exact path='/ppd/overview-summary' component={PPDOverview} />)}
                {this.isPermission('LOGS') && (<Route exact path='/reports/logs' component={TabsLogs} />)}
                {this.isPermission('WAGE_RATES') && (<Route exact path='/wage' component={LocationWage} />)}
                {this.isPermission("CLIENT_LIST") && (<Route exact path='/clients' component={ClientsView} />)}
                {this.isPermission("USERS_LIST") && (<Route exact path='/admin/users' component={Users} />)}
                {this.isPermission("ADMIN_RBAC_ACCESS") && (<Route exact path='/admin/Role' component={RoleView} />)}
                {(<Route exact path='/admin/login' component={AdminLogin} />)}
                {/* this.isPermission("TEAM_SUPPORT") && (<Route exact path='/team-support-history' component={TeamSupportHistory} />) */}
                {this.isPermission('TIME_INVENTORY') && (<Route exact path='/time-inventory' component={TimeInventory} />)}
                {this.isPermission('EMAIL_SETUP') && (<Route exact path='/email-setup' component={EmailSetup} />)}
                {this.isPermission('EDIT_ADMIN_REPORTS') && <Route exact path='/admin/report-settings/billing-services' component={BillingServices} />}
                {this.isPermission('EDIT_ADMIN_REPORTS') && <Route exact path='/admin/report-settings/management-billing' component={ManagementBillingView} />}
                {this.isPermission('EDIT_ADMIN_REPORTS') && <Route exact path='/admin/report-settings/annual-billing' component={AnnualBillingView} />}
                {this.isPermission('EDIT_ADMIN_REPORTS') && <Route exact path='/admin/report-settings/billing' component={BillingView} />}
                {this.isPermission('EDIT_ADMIN_REPORTS') && <Route exact path='/admin/report-settings/csr-assignments' component={CSRAssignments} />}
                {this.isPermission("EDIT_FINANCE_REPORTS") && <Route exact path='/admin/finance-reports/apar-comparison' component={AparComparisonSetupView} />}
                {this.isPermission("EDIT_FINANCE_REPORTS") && <Route exact path='/admin/finance-reports/annual-billing' component={AnnualBillingView} />}
                {this.isPermission("EDIT_FINANCE_REPORTS") && <Route exact path='/admin/finance-reports/ukg-invoices' component={ukgInvoices} />}
              </Switch>
            </div>
            <small >{this.state.VITE_VERSION}</small>
          </div>
        </div>
      </div >
      // <Header/>
      // <SideMenu/>
    );
  };
};


const mapStateToProps = ({ UserReducer, getPermissionActive, PermissionReducer, CompaniesReducer, ClientDataReducer }) =>
  ({ UserReducer, getPermissionActive, PermissionReducer, ClientDataReducer, CompaniesReducer });
const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loginAction,
    refreshUserAction,
    getCompanyPermissions,
    allCompanies,
    editClientData,
    refreshToken,
    refreshAuth
  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(HomeView);
